import { SearchMap } from "./views/SearchMap/SearchMap";
import './App.css';
import {
  BrowserRouter as Router,
  Route,
  Routes
} from "react-router-dom";
import React from "react";
import './App.css';
import { VerifyUser } from "./views/VerifyUser/VerifyUser";
import { UserRegistered } from "./views/VerifyUser/UserRegistered";
import { BinReturn } from "./views/BinReturn/BinReturn";
import { LoginHome } from "./views/VerifyUser/LoginHome";
import { Login } from "./views/VerifyUser/Login";
import { PaymentMethods } from "./views/VerifyUser/PaymentMethods";
import { ForgotPin } from "./views/VerifyUser/ForgotPin";

function App() {  
  return (
    <Router>
      <div>
        <Routes>
          <Route path="/return/:id" element={<BinReturn />}/>
          <Route path="/verify" element={<VerifyUser/>}/>
          <Route path="/registered" element={<UserRegistered/>}/>
          <Route path="/login" element={<Login/>}/>
          <Route path="/forgot-pin" element={<ForgotPin/>}/>
          <Route path="/payment-methods" element={<PaymentMethods/>}/>
          <Route path="/home" element={<LoginHome/>}/>
          <Route path="/status/:id" element={<SearchMap/>}/>
          <Route path="*" element={<Login/>}/>
        </Routes>
      </div>
    </Router>
  );
}

export default App;
